import styled from 'styled-components';
import { acceptgreen, lightgrey, white } from 'styles/Colors';

export const MenuItemsOuter = styled.div`
  width: 160px;
  display: none;
  position: absolute;
  top: 20px;
  padding-bottom: 10px;
  z-index: 100;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
  &.always-visible {
    display: block;
  }

  @media (min-width: 992px) {
    right: 12px;
  }
`;

export const MenuItems = styled.div`
  background-color: ${white};
  padding: 20px 14px 7px 14px;
  clip-path: polygon(0% 10%, 86% 10%, 92% 0%, 98% 10%, 100% 10%, 100% 100%, 0 100%);
`;

export const MenuItem = styled.div`
  cursor: pointer;
  &.disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const ItemText = styled.span`
  font-family: Lato;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.15;
  letter-spacing: 0.5px;
  text-transform: none;
  display: inline-block;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const Divider = styled.div`
  background-color: ${lightgrey};
  opacity: 0.37;
  width: 100%;
  height: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const AddPlayMenuWrapper = styled.div`
  width: 100%;
  svg {
    path {
      fill: ${acceptgreen};
    }
  }
  &:hover {
    .menu-items-outer {
      display: block;
    }
  }
  &.disabled {
    opacity: 0.5;
    &:hover {
      .menu-items-outer {
        display: none;
      }
    }
    svg {
      cursor: default;
    }
  }
`;
